import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';
import { NgxInnerLoadingModule } from 'ngx-inner-loading';

import { FaqHelpComponent } from './components/faq-help/faq-help.component';
import { MessageHelpComponent } from './components/message-help/message-help.component';
import { HelpMeComponent } from './help-me.component';

@NgModule({
  declarations: [HelpMeComponent, MessageHelpComponent, FaqHelpComponent],
  imports: [
    CommonModule,
    NgxBootstrapIconsModule,
    ProgressbarModule,
    FormsModule,
    NgxInnerLoadingModule,
  ],
  exports: [HelpMeComponent],
})
export class HelpMeUiModule {}
